import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const startMenu = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.75,
  type: 'SquareLogoMedia',
  associationType: 'start-SquareLogoMedia',
  imagePreviewHeight: 160,
  className: 'boost-start-menu',
  logoHeight: 24,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [280, 160],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Start Menu'),
    stringKey: _TL_('Start Menu'),
  },
  previewSettings: {
    previewContentClassName: 'boost-start-menu',
    showLogo: true,
    showShortHeadline: true,
    multipleLineLongHeadline: true,
    showLongHeadline: true,
    showAction: false,
    showBusinessName: false,
    showImage: false,
    showDismiss: true,
  },
  styleOverrides: {
    cardParent: {
      marginTop: 'auto',
      marginBottom: 'auto',
      '& .responsive-ad-preview-content': {
        width: '280px !important',
        height: 60,
        backgroundColor: '#262632',
      },
      '& .logo-container': {
        position: 'absolute',
        top: '50%',
        left: 10,
        transform: 'translateY(-50%)',
      },
      '& .short-headline': {
        position: 'absolute',
        top: 0,
        left: 0,
        fontSize: 12,
        width: 200,
        color: 'white',
      },
      '& .long-headline': {
        position: 'absolute',
        top: 15,
        left: 40,
        fontSize: 12,
        color: 'white',
      },
    },
  },
};

export default startMenu;
